import { REDPLUS_KIDS_GROUP, SalesChannel, SALESCHANNEL_SOHO } from '@vfde-fe/sails-constants';

/**
 * SOHO and RED+ are not eligible for trade-in, return false if it's the case
 * @param subscriptionId
 * @param salesChannel
 */
export const getIsTradeInEligible = (subscriptionId: string, salesChannel: SalesChannel) => {
    return !(([SALESCHANNEL_SOHO].indexOf(salesChannel) !== -1) || (subscriptionId === `${REDPLUS_KIDS_GROUP}`));
};
